export const iconFontAwesomeTogglePlaneUp = (
	<i className="fa-solid fa-plane-up"></i>
);
